const EXPIRATION_MS = 7 * 24 * 60 * 60 * 1000; // 7 days

interface StoredEntry<T> {
  data: T;
  timestamp: number;
}

export function saveOffline<T>(key: string, data: T): void {
  try {
    const entry: StoredEntry<T> = { data, timestamp: Date.now() };
    localStorage.setItem(key, JSON.stringify(entry));
  } catch (e) {
    console.warn('Failed to save offline data:', e);
  }
}

export function loadOffline<T>(key: string): T | null {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return null;
    const entry: StoredEntry<T> = JSON.parse(raw);
    if (Date.now() - entry.timestamp > EXPIRATION_MS) {
      localStorage.removeItem(key);
      return null;
    }
    return entry.data;
  } catch (e) {
    console.warn('Failed to load offline data:', e);
    return null;
  }
}

export function clearOffline(key: string): void {
  try {
    localStorage.removeItem(key);
  } catch (e) {
    console.warn('Failed to clear offline data:', e);
  }
}

// Offline-backup key for the breakdown editor. MUST be scoped per document
// when one is open (flag-on word-processor path): a job can have several
// documents, and a backup of one must never be recovered into another (doing
// so saved one doc's row ids to another → cross-document PK collision). When
// no documentId is given (legacy flag-off path) the key stays jobId-only so
// existing behavior is unchanged.
export function offlineBreakdownKey(jobId: string, documentId?: string): string {
  return documentId
    ? `jobos-offline-breakdown-${jobId}-${documentId}`
    : `jobos-offline-breakdown-${jobId}`;
}

export function offlineOverviewKey(jobId: string): string {
  return `jobos-offline-overview-${jobId}`;
}

export function offlineCarpetKey(jobId: string): string {
  return `jobos-offline-carpet-${jobId}`;
}

export function offlineEquipmentKey(jobId: string): string {
  return `jobos-offline-equipment-${jobId}`;
}
